const ageGate = document.querySelector('#age-gate');
const enterSite = document.querySelector('#enter-site');
const siteShell = document.querySelector('.site-shell');
const ageGatePanel = ageGate?.querySelector('.age-gate__panel');
let ageVerified = false;
try {
  ageVerified = sessionStorage.getItem('caliSunAgeVerified') === 'true';
} catch (error) {
  ageVerified = false;
}
if (ageVerified) {
  ageGate?.setAttribute('hidden', '');
} else {
  document.body.classList.add('age-gate-open');
  siteShell?.setAttribute('inert', '');
  requestAnimationFrame(() => enterSite?.focus());
}
enterSite?.addEventListener('click', () => {
  try {
    sessionStorage.setItem('caliSunAgeVerified', 'true');
  } catch (error) {
    ageVerified = true;
  }
  ageGate?.setAttribute('hidden', '');
  document.body.classList.remove('age-gate-open');
  siteShell?.removeAttribute('inert');
  document.querySelector('#MainContent')?.focus({ preventScroll: true });
});
ageGate?.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') return;
  const focusable = [...ageGate.querySelectorAll('button, a[href]')].filter((element) => !element.hasAttribute('disabled'));
  if (!focusable.length) {
    event.preventDefault();
    ageGatePanel?.focus();
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

const hamburger = document.querySelector('.hamburger-toggle');
const navigation = document.querySelector('.site-nav');
const closeNavigation = () => {
  navigation?.classList.remove('is-open');
  hamburger?.setAttribute('aria-expanded', 'false');
  if (hamburger) hamburger.textContent = '☰';
};
hamburger?.addEventListener('click', () => {
  const open = navigation.classList.toggle('is-open');
  hamburger.setAttribute('aria-expanded', String(open));
  hamburger.textContent = open ? '✕' : '☰';
});
navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeNavigation));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && navigation?.classList.contains('is-open')) {
    closeNavigation();
    hamburger?.focus();
  }
});
window.addEventListener('resize', () => {
  if (window.innerWidth >= 700) closeNavigation();
});

const flavorData = {
  cherry: { title: 'CHERRY', subtitle: 'Tangy Stone Fruit', variantFlavor: 'Cherry - Tangy Stone Fruit' },
  kiwi: { title: 'KIWI', subtitle: 'Golden Kiwi + Honeydew', variantFlavor: 'Kiwi - Golden Kiwi + Honeydew' },
  paradise: { title: 'PARADISE', subtitle: 'Strawberry + Pineapple + Orange', variantFlavor: 'Paradise - Strawberry + Pineapple + Orange' },
  soursop: { title: 'SOURSOP', subtitle: 'Spiky Tropical Fruit', variantFlavor: 'Soursop - Spiky Tropical Fruit' },
  sampler: { title: 'BUILD YOUR OWN', subtitle: 'Choose your own mix', variantFlavor: 'Build Your Own 6-Pack', packImage: true },
  variety: { title: 'VARIETY PACK', subtitle: 'Try them all', variantFlavor: 'Variety Pack - Try Them All', packImage: true }
};

const productForm = document.querySelector('[data-cali-product-form]');
const builder = document.querySelector('[data-sampler-builder]');
const flavorInputs = [...document.querySelectorAll('[data-flavor]')];
const packInputs = [...document.querySelectorAll('[data-pack-count]')];
const variantDataNode = document.querySelector('[data-cali-variants]');
const variants = variantDataNode ? JSON.parse(variantDataNode.textContent) : [];
const variantIdInput = productForm?.querySelector('[data-variant-id]');
const submitButton = productForm?.querySelector('[data-add-to-cart]');
const quantityInput = productForm?.querySelector('[data-product-quantity]');
const stickyCart = document.querySelector('[data-sticky-cart]');
const stickySubmit = document.querySelector('[data-sticky-submit]');
const stickyFlavor = document.querySelector('[data-sticky-flavor]');
const stickyPrice = document.querySelector('[data-sticky-price]');
const stickyImage = document.querySelector('[data-sticky-image]');
let activeVariant = null;

const formatMoney = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

const updateProductDetails = (flavor) => {
  const packFlavor = flavor === 'sampler' || flavor === 'variety';
  document.querySelectorAll('[data-flavor-copy]').forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.flavorCopy !== flavor));
  document.querySelectorAll('[data-flavor-expect]').forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.flavorExpect !== flavor));
  document.querySelectorAll('[data-flavor-full]').forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.flavorFull !== flavor));
  document.querySelectorAll('[data-facts-panel]').forEach((panel) => panel.toggleAttribute('hidden', packFlavor || panel.dataset.factsPanel !== flavor));
  document.querySelector('[data-sampler-facts]')?.toggleAttribute('hidden', !packFlavor);
};

const selectedFlavorInput = () => flavorInputs.find((input) => input.checked);
const selectedPackInput = () => packInputs.find((input) => input.checked && !input.disabled);
const selectedPackCount = () => Number(selectedPackInput()?.dataset.packCount || 6);

const updateSubmitState = () => {
  if (!submitButton) return;
  const samplerSelected = document.querySelector('[data-flavor="sampler"]')?.checked;
  const samplerTotal = [...document.querySelectorAll('[data-sampler-count]')].reduce((sum, input) => sum + Number(input.value), 0);
  const samplerTarget = selectedPackCount();
  const unavailable = !activeVariant || !activeVariant.available;
  submitButton.disabled = unavailable || (samplerSelected && samplerTotal !== samplerTarget);
  if (stickySubmit) stickySubmit.disabled = submitButton.disabled;
  if (unavailable) submitButton.textContent = submitButton.dataset.soldOutLabel;
};

const normalizeSamplerCounts = () => {
  const counts = [...document.querySelectorAll('[data-sampler-count]')];
  const target = selectedPackCount();
  let total = counts.reduce((sum, input) => sum + Number(input.value), 0);
  if (total <= target) return;
  [...counts].reverse().forEach((input) => {
    if (total <= target) return;
    const reduction = Math.min(Number(input.value), total - target);
    input.value = Number(input.value) - reduction;
    total -= reduction;
  });
};

const updateBuilder = () => {
  const counts = [...document.querySelectorAll('[data-sampler-count]')];
  const total = counts.reduce((sum, input) => sum + Number(input.value), 0);
  const totalNode = document.querySelector('[data-sampler-total]');
  const targetNode = document.querySelector('[data-sampler-target]');
  if (totalNode) totalNode.textContent = String(total);
  if (targetNode) targetNode.textContent = String(selectedPackCount());
  updateSubmitState();
};

const updatePackOfferPricing = (input, variant) => {
  const offer = input.closest('[data-pack-option]');
  if (!offer || !variant) return;
  const discount = Number(input.dataset.packDiscount || 0);
  const packCount = Number(input.dataset.packCount || 1);
  const finalPrice = Math.max(0, variant.price - discount);
  const retailNode = offer.querySelector('[data-pack-retail]');
  const finalNode = offer.querySelector('[data-pack-final]');
  const unitNode = offer.querySelector('[data-pack-unit]');
  if (retailNode) retailNode.textContent = formatMoney(variant.price);
  if (finalNode) finalNode.textContent = formatMoney(finalPrice);
  if (unitNode) unitNode.textContent = formatMoney(Math.round(finalPrice / packCount));
};

const updatePackAvailability = (data) => {
  packInputs.forEach((input) => {
    const matchingVariant = variants.find((variant) => variant.flavor === data.variantFlavor && variant.pack === input.value && variant.available);
    input.disabled = !matchingVariant;
    input.closest('[data-pack-option]')?.toggleAttribute('hidden', !matchingVariant);
    if (matchingVariant) updatePackOfferPricing(input, matchingVariant);
  });
  if (!selectedPackInput()) {
    const firstAvailablePack = packInputs.find((input) => !input.disabled);
    if (firstAvailablePack) firstAvailablePack.checked = true;
  }
};

const updateVariantSelection = () => {
  const flavorInput = selectedFlavorInput();
  const packInput = selectedPackInput();
  const data = flavorInput ? flavorData[flavorInput.dataset.flavor] : null;
  activeVariant = data && packInput ? variants.find((variant) => variant.flavor === data.variantFlavor && variant.pack === packInput.value) : null;
  if (!activeVariant) {
    updateSubmitState();
    return;
  }
  if (variantIdInput) variantIdInput.value = activeVariant.id;
  const retailPrice = activeVariant.price;
  const packCount = Number(packInput.dataset.packCount);
  if (flavorInput.dataset.flavor === 'sampler') {
    const subtitle = document.querySelector('[data-flavor-subtitle]');
    if (subtitle) subtitle.textContent = `Choose any ${packCount} cans`;
  }
  const orderQuantity = Math.max(1, Number(quantityInput?.value || 1));
  const totalCanCount = packCount * orderQuantity;
  const linePrice = retailPrice * orderQuantity;
  const subscriptionPrice = Math.round(linePrice * 0.8);
  document.querySelectorAll('[data-summary-price], [data-onetime-price], [data-subscribe-retail]').forEach((node) => { node.textContent = formatMoney(linePrice); });
  document.querySelectorAll('[data-onetime-per-can]').forEach((node) => { node.textContent = `${formatMoney(Math.round(linePrice / totalCanCount))} per can`; });
  document.querySelectorAll('[data-subscribe-price]').forEach((node) => { node.textContent = formatMoney(subscriptionPrice); });
  document.querySelectorAll('[data-subscribe-per-can]').forEach((node) => { node.textContent = `${formatMoney(Math.round(subscriptionPrice / totalCanCount))} per can`; });
  if (submitButton) submitButton.textContent = `${submitButton.dataset.addLabel} — ${formatMoney(linePrice)}`;
  if (stickyPrice) stickyPrice.textContent = formatMoney(linePrice);
  if (stickyFlavor && data) stickyFlavor.textContent = `${data.title} · ${totalCanCount} CANS`;
  updateSubmitState();
};

const updateFlavor = (input) => {
  const flavor = input.dataset.flavor;
  const data = flavorData[flavor];
  if (!data) return;
  const title = document.querySelector('[data-flavor-title]');
  const subtitle = document.querySelector('[data-flavor-subtitle]');
  const blobs = [...document.querySelectorAll('[data-flavor-blob]')];
  const cans = [...document.querySelectorAll('[data-flavor-can]')];
  const galleryFacts = [...document.querySelectorAll('[data-gallery-facts]')];
  const editorialImages = [...document.querySelectorAll('[data-gallery-editorial], [data-gallery-editorial-thumb]')];
  const thumbCans = [...document.querySelectorAll('[data-gallery-thumb-can]')];
  if (title) title.textContent = data.title;
  if (subtitle) subtitle.textContent = data.subtitle;
  if (stickyFlavor) stickyFlavor.textContent = data.title;
  if (stickyImage) stickyImage.src = data.packImage ? stickyImage.dataset.packSrc : stickyImage.dataset[`${flavor}Src`];
  document.querySelectorAll('[data-gallery-flavor-title]').forEach((node) => { node.textContent = data.title; });
  document.querySelectorAll('[data-gallery-flavor-subtitle]').forEach((node) => { node.textContent = data.subtitle; });
  builder?.toggleAttribute('hidden', flavor !== 'sampler');
  builder?.querySelectorAll('[data-sampler-count]').forEach((input) => {
    input.disabled = flavor !== 'sampler';
  });
  cans.forEach((can) => {
    if (data.packImage) {
      can.src = can.dataset.packSrc;
      can.alt = `${data.title} Cali-Sun Future Soda pack`;
      can.classList.add('pdp-media__can--pack');
    } else {
      can.src = can.dataset[`${flavor}Src`];
      can.alt = `${data.title} Cali-Sun Future Soda can`;
      can.classList.remove('pdp-media__can--pack');
    }
  });
  blobs.forEach((blob) => {
    blob.toggleAttribute('hidden', Boolean(data.packImage));
    if (!data.packImage) blob.src = blob.src.replace(/[^/]+-blob\.png/, `${flavor}-blob.png`);
  });
  editorialImages.forEach((image) => {
    image.src = data.packImage ? image.dataset.packSrc : image.dataset[`${flavor}Src`];
    image.alt = data.packImage ? `${data.title} Cali-Sun flavor lineup` : `${data.title} Cali-Sun flavor world`;
  });
  thumbCans.forEach((can) => {
    can.src = data.packImage ? can.dataset.packSrc : can.dataset[`${flavor}Src`];
    can.classList.toggle('is-pack-image', Boolean(data.packImage));
  });
  galleryFacts.forEach((facts) => {
    facts.src = data.packImage ? facts.dataset.packSrc : facts.dataset[`${flavor}Src`];
    facts.alt = data.packImage ? `${data.title} Cali-Sun flavor lineup` : `${data.title} Cali-Sun nutrition facts and ingredients panel`;
    facts.classList.toggle('is-pack-image', Boolean(data.packImage));
  });
  updateProductDetails(flavor);
  updatePackAvailability(data);
  updateVariantSelection();
  updateBuilder();
};

flavorInputs.forEach((input) => input.addEventListener('change', () => updateFlavor(input)));
packInputs.forEach((input) => input.addEventListener('change', () => {
  if (quantityInput) quantityInput.value = '1';
  normalizeSamplerCounts();
  updateVariantSelection();
  updateBuilder();
}));

builder?.querySelectorAll('[data-sampler-plus], [data-sampler-minus]').forEach((button) => {
  button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('[data-sampler-count]');
    const total = [...document.querySelectorAll('[data-sampler-count]')].reduce((sum, node) => sum + Number(node.value), 0);
    if (button.hasAttribute('data-sampler-plus') && total < selectedPackCount()) input.value = Number(input.value) + 1;
    if (button.hasAttribute('data-sampler-minus') && Number(input.value) > 0) input.value = Number(input.value) - 1;
    updateBuilder();
  });
});

const gallery = document.querySelector('[data-pdp-gallery]');
if (gallery) {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const tabs = [...gallery.querySelectorAll('[data-gallery-target]')];
  const current = gallery.querySelector('[data-gallery-current]');
  const stage = gallery.querySelector('.pdp-gallery__stage');
  const thumbnailRail = gallery.querySelector('.pdp-gallery__thumbs');
  const mobileGallery = window.matchMedia('(max-width: 699px)');
  let activeIndex = 0;
  let touchStartX = null;

  const activateGallerySlide = (index, moveFocus = false) => {
    const safeIndex = (index + slides.length) % slides.length;
    activeIndex = safeIndex;
    slides.forEach((slide, slideIndex) => slide.toggleAttribute('hidden', slideIndex !== safeIndex));
    tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === safeIndex;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    if (current) current.textContent = String(safeIndex + 1);
    if (moveFocus) tabs[safeIndex]?.focus();

    if (mobileGallery.matches && thumbnailRail && tabs[safeIndex]) {
      const activeTab = tabs[safeIndex];
      const centeredPosition = activeTab.offsetLeft - ((thumbnailRail.clientWidth - activeTab.clientWidth) / 2);
      thumbnailRail.scrollTo({
        left: Math.max(0, centeredPosition),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateGallerySlide(index));
    tab.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activateGallerySlide(index + 1, true);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activateGallerySlide(index - 1, true);
      }
      if (event.key === 'Home') {
        event.preventDefault();
        activateGallerySlide(0, true);
      }
      if (event.key === 'End') {
        event.preventDefault();
        activateGallerySlide(slides.length - 1, true);
      }
    });
  });

  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => activateGallerySlide(activeIndex - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => activateGallerySlide(activeIndex + 1));
  stage?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
  stage?.addEventListener('touchend', (event) => {
    if (touchStartX === null) return;
    const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
    if (Math.abs(distance) > 48) activateGallerySlide(activeIndex + (distance < 0 ? 1 : -1));
    touchStartX = null;
  }, { passive: true });
}

const requestedFlavor = new URLSearchParams(window.location.search).get('flavor');
const requestedFlavorAliases = { halo: 'kiwi', solstice: 'paradise', byo: 'sampler' };
const normalizedRequestedFlavor = requestedFlavorAliases[requestedFlavor] || requestedFlavor;
const requestedFlavorInput = document.querySelector(`[data-flavor="${normalizedRequestedFlavor}"]`);
const initialFlavorInput = requestedFlavorInput || flavorInputs[0];
if (initialFlavorInput) {
  initialFlavorInput.checked = true;
  updateFlavor(initialFlavorInput);
}

stickySubmit?.addEventListener('click', () => {
  if (!submitButton?.disabled) productForm?.requestSubmit(submitButton);
});

if (submitButton && stickyCart) {
  const mobileStickyCart = window.matchMedia('(max-width: 699px)');
  let stickyUpdateQueued = false;

  const updateStickyCart = () => {
    stickyUpdateQueued = false;
    const submitRect = submitButton.getBoundingClientRect();
    const submitIsVisible = submitRect.top < window.innerHeight && submitRect.bottom > 0;
    const mobileScrollThreshold = Math.min(window.innerHeight * 0.45, 420);
    const showStickyCart = mobileStickyCart.matches
      ? window.scrollY > mobileScrollThreshold && !submitIsVisible
      : submitRect.bottom < 0;
    stickyCart.classList.toggle('is-visible', showStickyCart);
    stickyCart.setAttribute('aria-hidden', String(!showStickyCart));
  };

  const queueStickyCartUpdate = () => {
    if (stickyUpdateQueued) return;
    stickyUpdateQueued = true;
    window.requestAnimationFrame(updateStickyCart);
  };

  updateStickyCart();
  window.addEventListener('scroll', queueStickyCartUpdate, { passive: true });
  window.addEventListener('resize', queueStickyCartUpdate);
}
